import React, { Component } from 'react'
import shortid from 'shortid'
import { withStyles } from '@material-ui/styles'
import { CalendarForm } from '../forms'
import { Dashboard } from '../layouts'
import axios from '../plugins/axios'

const styles = theme => ({
    //
})

class CalendarNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Calendar',
            key: shortid.generate(),
            tours: []
        }
    }

    componentDidMount = () => {
        this.fetchTours()
    }

    fetchTours = async () => {
        try {
            const { data } = await axios.get('/tours', {
                progress: true,
                params: {
                    rowsPerPage: -1,
                    sortBy: 'name',
                    sortOrder: 'asc'
                }
            })

            this.setState({
                key: shortid.generate(),
                tours: data
            })
        } catch (e) {
            //
        }
    }

    render() {
        const {
            key,
            title,
            tours
        } = this.state
        return (
            <Dashboard title={title}>
                <CalendarForm 
                    key={key}
                    path="calendar"
                    method="post"
                    tours={tours}
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(CalendarNew)
